import React from "react";
import Assets from "../Layouts/Assets";
import Style from "./BlankFamilyMembers.module.scss";
import { useNavigate } from "react-router-dom";

const BlankFamilyMembers = ({
  title,
  description,
  buttonText,
  handleClick,
  className,
  imagePath,
}) => {
  let navigate = useNavigate();

  const addToFamily = () => {
    navigate("/dashboard/family-tree");
  };

  return (
    <div className={`${Style.gallery_blank_page} ${className}`}>
      <div className={Style.gallery_blank_page_wrap}>
        <figure className={Style.gallery_blank_page_image}>
          <img
            src={imagePath ? imagePath : Assets.file_upload_image}
            alt="photo_thumb"
          />
        </figure>
        <h2 className={Style.gallery_blank_page_title}>{title}</h2>
        <p className={Style.gallery_blank_page_description}>{description}</p>
        {buttonText ? (
          <button
            className={`${Style.gallery_blank_page_btn} btn btn-secondary`}
            onClick={addToFamily}
          >
            {buttonText}
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default BlankFamilyMembers;
